/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ assignee: NonNullable<unknown>, project: NonNullable<unknown> }} Explorer_Assignment_Email_Prompt_TextInputs */

const en_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send an email to ${i?.assignee} letting them know they were assigned to "${i?.project}"?`)
};

const fr_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Envoyer un e-mail a ${i?.assignee} pour l'informer qu'il a ete assigne au projet « ${i?.project} » ?`)
};

const de_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-Mail an ${i?.assignee} senden mit der Mitteilung, dass „${i?.project}" zugewiesen wurde?`)
};

const it_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inviare un'email a ${i?.assignee} per informarlo dell'assegnazione a "${i?.project}"?`)
};

const ru_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправить письмо адресату ${i?.assignee}, чтобы сообщить о назначении на проект «${i?.project}»?`)
};

const es_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Enviar un correo a ${i?.assignee} para informarle que se le asignó "${i?.project}"?`)
};

const zh_cn2_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`是否向 ${i?.assignee} 发送邮件，告知已将其分配给「${i?.project}」？`)
};

const ja_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.assignee} に「${i?.project}」への割り当てをメールで知らせますか？`)
};

const hi_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.assignee} को "${i?.project}" असाइन होने की सूचना ईमेल से दें?`)
};

const pt_pt2_explorer_assignment_email_prompt_text = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar um e-mail a ${i?.assignee} a informar que foi atribuído a "${i?.project}"?`)
};

/**
* | output |
* | --- |
* | "Send an email to {assignee} letting them know they were assigned to \"{project}\"?" |
*
* @param {Explorer_Assignment_Email_Prompt_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_prompt_text = /** @type {((inputs: Explorer_Assignment_Email_Prompt_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Prompt_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_assignment_email_prompt_text(inputs)
	if (locale === "de") return de_explorer_assignment_email_prompt_text(inputs)
	if (locale === "it") return it_explorer_assignment_email_prompt_text(inputs)
	if (locale === "ru") return ru_explorer_assignment_email_prompt_text(inputs)
	if (locale === "es") return es_explorer_assignment_email_prompt_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_assignment_email_prompt_text(inputs)
	if (locale === "ja") return ja_explorer_assignment_email_prompt_text(inputs)
	if (locale === "hi") return hi_explorer_assignment_email_prompt_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_assignment_email_prompt_text(inputs)
	return en_explorer_assignment_email_prompt_text(inputs)
});